'use client'

import type { CSSProperties, ReactNode } from 'react'

import { cn } from '@/lib/utils'

// The app's own column (LearnFrame's `main`: max-w-2xl, px-5 / md:px-8),
// inert: no focus, no pointer events, no handlers wired. `contain-paint`
// makes it the containing block for the app's bottom-fixed affordances, so
// they dock inside the specimen instead of the viewport.
//
// The app's action colour is vermilion (`bg-action`, `text-action`); inside
// an inert specimen it would read as a live second CTA beside the door
// (spec §6). The frame re-points the token family to the ink register.
const INERT_ACTION = {
    '--color-action': 'var(--color-ink)',
    '--color-action-hover': 'var(--color-ink)',
    '--color-action-pressed': 'var(--color-ink)',
    '--color-action-on': 'var(--color-paper)',
} as CSSProperties

export function SpecimenFrame({
    children,
    className,
    beat,
}: {
    children: ReactNode
    className?: string
    beat: number
}) {
    return (
        <div
            inert
            data-beat={beat}
            style={INERT_ACTION}
            className={cn(
                'relative mx-auto flex min-h-full w-full max-w-2xl flex-col bg-paper px-5 pt-8 pb-32 text-ink contain-paint md:px-8 md:pt-12 md:pb-28',
                className
            )}
        >
            {children}
        </div>
    )
}
